// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from './UserComponent';
import Phaser from 'phaser';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class UIPositionContainer extends UserComponent {
  constructor(gameObject: Phaser.GameObjects.Container) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)['__UIPositionContainer'] = this;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Container): UIPositionContainer {
    return (gameObject as any)['__UIPositionContainer'];
  }

  private gameObject: Phaser.GameObjects.Container;
  public offsetX: number = 0;
  public offsetY: number = 0;
  public PinLeft: boolean = false;
  public PinRight: boolean = false;
  public PinTop: boolean = false;
  public PinToBottom: boolean = false;
  public IgnoreSize: boolean = false;

  /* START-USER-CODE */

  protected awake() {
    this.scene.scale.on('resize', this.resize, this);
    this.reposition(this.scene.scale.width, this.scene.scale.height);
  }

  protected resize(gameSize: Phaser.Structs.Size, baseSize: number, displaySize: number, resolution: number) {
    var width = gameSize.width;
    var height = gameSize.height;
    this.reposition(width, height);
  }

  protected reposition(width: number, height: number) {
    let canvasBounds = this.scene.game.canvas.getBoundingClientRect();
    let heightMod = 768 / window.innerHeight;

    if (this.PinRight) {
      let right = 1920 / 2 + (window.innerWidth * heightMod) / 2;
      right = Math.min(right, 1920);

      if (this.IgnoreSize) this.gameObject.x = right - this.offsetX;
      else this.gameObject.x = right - this.gameObject.getBounds().width / 2 - this.offsetX;
    }

    if (this.PinLeft) {
      let left = 1920 / 2 - (window.innerWidth * heightMod) / 2;
      left = Math.max(left, 0);

      if (this.IgnoreSize) this.gameObject.x = left + this.offsetX;
      else this.gameObject.x = left + this.gameObject.getBounds().width / 2 + this.offsetX;
    }

    if (this.PinTop) {
      if (this.IgnoreSize) this.gameObject.y = this.offsetY;
      else this.gameObject.y = this.gameObject.getBounds().height / 2 + this.offsetY;
    }

    if (this.PinToBottom) {
      let top = canvasBounds.bottom;
      top = Math.min(top, canvasBounds.height);

      if (this.IgnoreSize) this.gameObject.y = top * (height / canvasBounds.height) - this.offsetY;
      else this.gameObject.y = top * (height / canvasBounds.height) - (this.gameObject.getBounds().height / 2 + this.offsetY);
    }

    if (isNaN(this.gameObject.x)) this.gameObject.x = 0;
    if (isNaN(this.gameObject.y)) this.gameObject.y = 0;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
